import React from 'react';
import cx from 'classnames';

import { LoadingArrow } from 'Storybook/components/local/LoadingArrow/LoadingArrow';

import styles from './DialogLoader.scss';

type DialogLoaderProps = {
  readonly className?: string;
  readonly hideLabel?: boolean;
  readonly message?: string;
  readonly panel?: boolean;
}

const DialogLoader = ({ className = '', hideLabel = false, message = '', panel = false }: DialogLoaderProps) => (
  <div className={cx(styles.component, { [styles.extraBottomPadding]: panel })} data-testid='dialog-loader'>
    <div className={cx(styles.dialogWrapper, { [styles.panel]: panel, [className]: className })}>
      <LoadingArrow showText={!hideLabel && !!message} size="large" text={message} />
    </div>
  </div>
);

export default DialogLoader;
